import PlayerIdChip from 'src/features/profile/player/setupModal/components/PlayerIdChip'

interface RegistrationIdChipsProps {
  /** Team registrations: the team's id. */
  teamId?: string | null
  /** Player registrations: the player's id. */
  playerId?: string | null
  registrationId?: string | null
  /** Chip fill, for a surface the default one blends into (the modal header). */
  chipBackground?: string
}

/**
 * The copyable IDs for a registration — its team or player, then the
 * registration itself — for the registration header's actions slot. Same chip
 * as the Edit Player and Player Details ID chips.
 */
const RegistrationIdChips = ({
  teamId,
  playerId,
  registrationId,
  chipBackground,
}: RegistrationIdChipsProps) => (
  <>
    {teamId ? (
      <PlayerIdChip
        playerId={teamId}
        label='TEAM ID'
        idName='Team ID'
        backgroundColor={chipBackground}
      />
    ) : null}
    {playerId ? (
      <PlayerIdChip playerId={playerId} backgroundColor={chipBackground} />
    ) : null}
    {registrationId ? (
      <PlayerIdChip
        playerId={registrationId}
        label='REGISTRATION ID'
        idName='Registration ID'
        backgroundColor={chipBackground}
      />
    ) : null}
  </>
)

export default RegistrationIdChips
